module.exports = __webpack_public_path__ + "media/18zl.6727f2a1.mp3";